<template>
    <div class="notice-main">
        <span class="notice-icon" @mouseenter="visible = true" @mouseleave="visible = false"></span>
        <div class="notice-tip" :style="{top: top + 'px'}" v-show="visible">
            <p v-for="(item, index) in list">{{ item }}</p>
            <span></span>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            visible: false
        }
    },
    props: {
        list: {
            type: Array,
            default () {
                return []
            }
        }
    },
    computed: {
        top () {
            return -this.list.length * 20 - 44
        }
    }
}
</script>
<style lang="scss" scoped>
    .notice-main {
        display: inline-block;
        vertical-align: middle;
        position: relative;
        width: 17px;
        height: 17px;
    }
    .notice-icon {
        width: 17px;
        height: 17px;
        cursor: pointer;
        display: inline-block;
        background: url(http://i.thsi.cn/images/backtest/icon.png) no-repeat -58px -51px;
        position: absolute;
        top: 0;
        left: 0;
    }
    .notice-tip {
        width: 320px;
        background: #fff;
        border: 1px solid #d6d6d6;
        padding: 15px;
        position: absolute;
        left: -10px;
        p {
            width: 100%;
            line-height: 20px;
            font-weight: 100;
            font-size: 12px;
        }
        span:nth-of-type(1){
            display: block;
            width: 0;
            height: 0;
            border-top: 10px solid #d6d6d6;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            position: absolute;
            bottom: -10px;
            left: 6px;
            &:after {
                content: '';
                width: 0;
                border-top: 9px solid #fff;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                position: absolute;
                bottom: 2px;
                left: -8px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/lib/notice-tip.vue